import { UpdatePromptBanner } from "@drs-ops/ui/feedback";
import { useVersionCheck } from "@drs-ops/ui/hooks";
import { AppShell as PackageAppShell } from "@drs-ops/ui/layout";
import { Outlet } from "@tanstack/react-router";
import { Header } from "./Header";

const mode = import.meta.env.MODE as string;

const modeColour: Record<string, string> = {
  development: "text-amber-500",
  staging: "text-blue-600",
};

export function AppShell(): React.ReactElement {
  // Polls /api/health; a different build id there means a newer deploy is live.
  const { needRefresh, current, latest } = useVersionCheck({ current: __BUILD_ID__ });

  const footer = (
    <div className="py-2 text-center text-xs text-muted-foreground select-none">
      v{__BUILD_ID__}
      {import.meta.env.DEV && <span className="text-amber-500"> · local</span>}
      {mode !== "production" && (
        <span className={modeColour[mode] ?? "text-muted-foreground"}>
          {" · "}
          {mode}
        </span>
      )}
    </div>
  );

  return (
    <PackageAppShell header={<Header />} footer={footer}>
      <Outlet />
      {needRefresh && (
        <UpdatePromptBanner
          onReload={() => window.location.reload()}
          fromVersion={current}
          {...(latest ? { toVersion: latest } : {})}
        />
      )}
    </PackageAppShell>
  );
}
